<script>
export default {
  name: 'LeftPanelInstructions',
  data () {
    return {
      leftPanelInstructions: [
        this.$gettext('Click on a line to select it'),
        this.$gettext('Click on the button at the top right to draw a new line'),
      ],
    }
  },
}
</script>
<template>
  <div class="left-panel-instructions">
    <v-list density="compact">
      <v-list-item
        v-for="(instruction, index) in leftPanelInstructions"
        :key="'i' + index"
        prepend-icon="fas fa-circle-info"
      >
        {{ instruction }}
      </v-list-item>
    </v-list>
  </div>
</template>
<style lang="scss" scoped>
.left-panel-instructions {
  display: flex;
  flex-direction: column;
  font-size: 0.85rem;
}
:deep(.v-icon) {
  color: $primary;
  opacity: 1 !important;
}
</style>
